import { windowUtils } from '@packages/domain/utils/windowUtils/windowUtils';

const BrowserRepository = {
  getFlywireSubdomain() {
    const host = windowUtils.getHost();
    const match = host.match(/(flywire.*)/) || [];

    return match[0];
  },
};

export { BrowserRepository };
